import React, {useEffect, useState, Context} from "react";
import {FieldAttributes, useField, useFormikContext} from "formik";
import "./index.scss";
import {Autocomplete} from "@material-ui/lab"
import {CircularProgress, TextField, FormControl} from "@material-ui/core";
import KeyboardArrowDownOutlined from '@material-ui/icons/KeyboardArrowDownOutlined'
import {IFormattedResponse} from "../../../model/parametrizedResponse";
import {IResponseField} from "../../../model/reactField";
import {ISettingOption} from "../../../model/settingItem";
import { strings } from "../../../strings/strings";
export interface SelectOption {
    label: string;
    value: any;
}
export interface ShortcutData {
    label: string;
    value: SelectOption;
}
interface Props {
    placeholder: string;
    loadFunction: (query?: string) => Promise<any[]>;
    charactersToSearch?: number;
    asOption: (obj: any) => SelectOption;
    fromOption: (option: SelectOption) => any;
    noOptionsText?: string;
    shortcutData?: ShortcutData[];
    disabled: boolean;
    hidden: boolean;
    error?: boolean;
    errorMessage?: string;
    setFieldToUpdate: (fieldToUpdate: IResponseField) => void;
    formatResponse: (obj: any) => IFormattedResponse;
    backEndName: string;
    formatSelected?: (obj: any) => ISettingOption;
    contextPath?: string;
    extFieldToUpdate?: IResponseField; //deprecate
    setExtFieldToUpdate?: any;  //deprecate
    onChangeListener?(args: any): void;
}

export const SelectAutocompleteOld = (props: FieldAttributes<Props>) => {
    const {name, disabled, hidden, error, errorMessage} = props;
    const {placeholder, loadFunction, charactersToSearch, asOption, fromOption, noOptionsText,
        shortcutData, setFieldToUpdate, formatResponse, backEndName, formatSelected, contextPath, onChangeListener} = props;
    const [field, _, helpers] = useField({name});
    const [open, setOpen] = useState(false);

    const [selectedOption, setSelectedOption] = useState<SelectOption>(field.value ?  formatSelected(field.value) : null);
    const [options, setOptions] = useState<SelectOption[]>([]);
    const loading = open && options.length === 0 && charactersToSearch === undefined;
    const {handleBlur} = useFormikContext();

    useEffect(() => {
        if (props.extFieldToUpdate && props.extFieldToUpdate.name === name) {
            setValue(props.extFieldToUpdate.value);
            props.setExtFieldToUpdate(null);
        }
    }, [props.extFieldToUpdate]);

    function setValue(value: SelectOption | string) {
        let formattedValue = value == null ? {quotationValue: null, value: null} : formatResponse(value);
        helpers.setValue(formattedValue.quotationValue);
        setSelectedOption(value as SelectOption);
        setFieldToUpdate({name: backEndName, value: formattedValue.value, contextPath : contextPath? contextPath: 'mainContract'});
    }

    const handleChange = (event: React.ChangeEvent<{}>, value: SelectOption | string) => {
        setValue(value);
        if(onChangeListener) {
            onChangeListener(value)
        }
    };

    const handleChangeText = (event: React.ChangeEvent<{ value: unknown }>) => {
        let inputValue = event.target.value == null ? '' : event.target.value.toString();
        if (inputValue !== '' && inputValue.length >= charactersToSearch) {
            (async () => {
                const response = await loadFunction(inputValue);
                setOptions(response.map(asOption));
            })();
        }
    };

    useEffect(() => {
        let active = true;
        if (!loading) {
            return undefined;
        }
        (async () => {
            const response = await loadFunction();
            if (active) {
                setOptions(response.map(asOption));
            }
        })();

        return () => {
            active = false;
        };

    }, [loading]);

    React.useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter' && event.target.value !== "") {
            let foundOption = options.find(value => value.label === event.target.value);
            if (foundOption !== undefined) {
                setSelectedOption(foundOption);
                helpers.setValue(fromOption(foundOption));
                setOpen(false);
            }
            event.preventDefault();
            event.stopPropagation();
        }
    };
    return (
        <div className={'select-autocomplete'}>
             <FormControl className={`select-one-input__select ${open ? 'arrow-style-open' : 'arrow-style-close'}`} error={errorMessage !==  ''} variant="outlined" fullWidth={true}>
                    <Autocomplete
                        hidden={hidden}
                        id={name}
                        options={options}
                        open={open}
                        onOpen={() => {
                            setOpen(true);
                        }}
                        onClose={() => {
                            setOpen(false);
                        }}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        getOptionSelected={(option, value) => option.value === value.value}
                        getOptionLabel={(option) => option.label ? option.label : ''}
                        loading={loading}
                        disabled={disabled}
                        value={selectedOption}
                        onKeyDown={handleKeyDown}
                        popupIcon={<KeyboardArrowDownOutlined />}
                        noOptionsText={noOptionsText ? noOptionsText : ""}
                        title={selectedOption?.label}
                        clearText={strings.actions.clear}
                        closeText={strings.actions.close}
                        openText={strings.actions.open}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                error={error}
                                helperText={errorMessage}
                                label={placeholder}
                                variant="outlined"
                                onChange={handleChangeText}
                                SelectProps={{
                                    MenuProps: {
                                        transitionDuration: 0,
                                    }
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}/>
                        )}
                    />
                    {shortcutData !== undefined && (
                        <div className={'shortcut-data'}>
                            {shortcutData.map((item, index) => {
                                return <span key={index} onClick={() => {
                                    setValue(item.value)
                                }}>{item.label}</span>
                            })}

                        </div>
                    )}
                </FormControl>
        </div>
    )
};
